import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env';


@Injectable()
export class SamlService {
  private baseUrl = 'https://smartlions.me/saml/auth';
  private apiUrl = environment.apiUrl

  constructor(private http: HttpClient) {}

  getTokenData(token: string) {
    const url = `${this.baseUrl}?token=${token}`;

    return this.http.get(url);
  }

  getRedirectUrl(samlResponse:string, relayState:string){
    samlResponse = encodeURIComponent(samlResponse);
    relayState = encodeURIComponent(relayState);
    const url = `${this.apiUrl}/saml/login?SAMLRequest=${samlResponse}&RelayState=${relayState}`;
    return this.http.get(url);
  }
}